<template>
  <div class="outsidePrice">
    <!-- 搜索 -->
    <div class="search">
      <el-form :model="searchForm" :rules="searchRules" ref="searchForm" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="6">
            <!-- 部门 -->
            <el-form-item
              :label="$t('outsidePrice.label.businessDepartmentCode')"
              prop="businessDepartmentCode"
            >
              <el-select
                clearable
                v-model="searchForm.businessDepartmentCode"
                :placeholder="$t('outsidePrice.placeholder.businessDepartmentCode')"
                filterable
              >
                <el-option
                  v-for="item of departmentList"
                  :key="item.personDepartmentCode"
                  :label="item.personDepartmentName"
                  :value="item.personDepartmentCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 商品大类 -->
            <el-form-item :label="$t('outsidePrice.label.productName')" prop="productParentName">
              <SearchModal
                ref="searchModal"
                :model="searchForm.productParentName"
                className="customer-search"
                :placeholder="$t('outsidePrice.placeholder.productName')"
                width="800"
                :propName="searchDialog.propName"
                :API="searchDialog.API"
                :query="searchDialog.query"
                :page="true"
                :isMultiple="true"
                :searchColumns="searchDialog.searchColumns"
                :columnList="searchDialog.columnList"
                @setSearchModal="setSearchModal"
              ></SearchModal>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 商品小类 -->
            <el-form-item :label="$t('outsidePrice.label.productDetailName')" prop="productCode">
              <el-select clearable filterable v-model="searchForm.productCode">
                <el-option
                  v-for="item of detailProductList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 搜索/重置按钮 -->
            <div class="searchBtns">
              <!--<el-button type="primary" @click="search">{{$t('search.search')}}</el-button>-->
              <!--<el-button @click="reset">{{$t('search.reset')}}</el-button>-->
              <!--<a class="search-expand" @click="toggle">{{expandText}}</a>-->
              <!--<i style="cursor:pointer;font-size:12px;color:#6299fe;margin-left:-3px;" :class="icon" ></i>-->

              <a href="javascript:;" class="search-btn" @click="search()">
                <img src="../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
              >
              <a href="javascript:;" class="reset" @click="reset('queryFrom')">
                <img src="../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
              >
              <div :class="{ 'open-btn': true, active: expand }" @click="toggle">
                <img src="../../../assets/tableImg/open-btn.svg" alt="" />
              </div>
            </div>
          </el-col>
        </el-row>
        <div :style="{ display: expand ? 'block' : 'none' }">
          <el-row :gutter="24">
            <el-col :span="6">
              <!-- 价格类型 -->
              <el-form-item
                :label="$t('outsidePrice.label.externalPriceType')"
                prop="externalPriceType"
              >
                <el-cascader
                  :props="{ expandTrigger: 'hover' }"
                  v-model="searchForm.externalPriceType"
                  :options="externalPriceTypeList"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 合作伙伴 -->
              <el-form-item label="合作伙伴名称" prop="partnerName">
                <el-input v-model="searchForm.partnerName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <!-- 产品属性 -->
              <el-form-item
                :label="$t('outsidePrice.label.productProperty')"
                prop="productProperty"
              >
                <el-checkbox-group v-model="searchForm.productProperty">
                  <el-checkbox
                    v-for="item of productPropertyList"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <!-- 交易币种 -->
              <el-form-item
                :label="$t('outsidePrice.label.tradeCurrency')"
                prop="tradeCurrencyCode"
              >
                <el-radio-group
                  @change="tradeCurrencyChange"
                  v-model="searchForm.tradeCurrencyCode"
                >
                  <el-radio
                    v-for="item of oftenCurrencyList"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}</el-radio
                  >
                  <el-radio label="other">
                    <!-- 其他货币 -->
                    {{ $t('outsidePrice.label.otherCurrency') }}
                    <template>
                      <el-select
                        size="mini"
                        style="width: 80px"
                        filterable
                        @focus="otherCurrencyFocus"
                        v-model="searchForm.otherCurrency"
                      >
                        <el-option
                          v-for="item of tradeCurrencyList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <!-- 货物状态 -->
              <el-form-item :label="$t('outsidePrice.label.productStatus')" prop="productStatus">
                <el-checkbox-group v-model="searchForm.productStatus">
                  <el-checkbox
                    v-for="item of productStatusList"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <!-- 交易市场 -->
              <el-form-item :label="$t('outsidePrice.label.tradeMarket')" prop="tradeMarket">
                <el-checkbox-group v-model="searchForm.tradeMarket">
                  <el-checkbox
                    v-for="item of tradeMarketList"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <!-- 开始时间 -->
              <el-form-item :label="$t('outsidePrice.label.startTime')" prop="startTime">
                <el-date-picker
                  clearable
                  v-model="searchForm.startTime"
                  type="date"
                  :placeholder="$t('outsidePrice.placeholder.startTime')"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerStartOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 结束时间 -->
              <el-form-item :label="$t('outsidePrice.label.endTime')" prop="endTime">
                <el-date-picker
                  clearable
                  v-model="searchForm.endTime"
                  type="date"
                  :placeholder="$t('outsidePrice.placeholder.endTime')"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerEndOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <!-- 显示上述日期范围内均价 -->
              <el-form-item prop="averagePrice">
                <el-checkbox @change="getPriceValue" v-model="searchForm.averagePrice">{{
                  $t('outsidePrice.label.showAveragePrice')
                }}</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!-- 均价 -->
              <el-form-item class="isShowLabel" prop="averagePriceValue">
                <el-input readonly v-model="searchForm.averagePriceValue"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
    <price-echart ref="priceEchart" :tableData="tableData" />
    <SiruiUpload ref="siruiUpload" @getData="getData" :action="action" :data="importData" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import * as rule from './rules';
  import SearchModal from '@/components/SearchModal';
  import SiruiTable from '@/components/SiruiTable';
  import PriceEchart from './priceEchart';
  import API from '@/api/masterData/outsidePrice';
  import { dateFormat } from '@/filters';
  import SiruiUpload from '@/components/SiruiUpload';

  export default {
    name: 'outsidePrice',
    components: {
      SearchModal,
      SiruiTable,
      PriceEchart,
      SiruiUpload,
    },
    computed: {
      action() {
        return API.IMPORT_API;
      },
      columnListDefault() {
        return [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            type: 'seq',
            visible: true,
            width: '50',
            fixed: 'left',
            title: 'table.index',
          },
          {
            field: 'priceCreateTime',
            title: this.isHnFlag
              ? 'outsidePrice.label.priceCreateTimeHn'
              : 'outsidePrice.label.priceCreateTime',
            visible: true,
          },
          {
            field: 'businessDepartmentName',
            title: 'outsidePrice.label.businessDepartmentName',
            visible: true,
          },
          {
            field: 'productName',
            title: 'outsidePrice.label.detailProductDisplayName',
            visible: true,
          },
          {
            field: 'priceType',
            title: 'outsidePrice.label.externalPriceType',
            visible: true,
          },
          {
            field: 'priceValue',
            title: 'outsidePrice.label.priceValue',
            visible: true,
          },
          {
            field: 'productPropertyName',
            title: 'outsidePrice.label.productProperty',
            visible: true,
          },
          {
            field: 'tradeCurrencyName',
            title: 'outsidePrice.label.tradeCurrency',
            visible: true,
          },
          {
            field: 'productStatusName',
            title: 'outsidePrice.label.productStatus',
            visible: true,
          },
          {
            field: 'tradeMarketName',
            title: 'outsidePrice.label.tradeMarket',
            visible: true,
          },
          {
            field: 'partnerName',
            title: '合作伙伴',
            visible: this.isHnFlag,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        // 常用货币
        oftenCurrencyList: function () {
          return this.$baseRequest.getDictListMapByType('often_currency') || [];
        },
      }),
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          businessDepartmentCode: this.userInfo.departmentCode,
          businessDepartmentName: this.userInfo.departmentName,
          access_token: this.userInfo.access_token,
        };
      },
      // 查询条件表单校验规则
      searchRules() {
        return {
          businessDepartmentCode: [
            { required: true, message: '请选择部门', trigger: ['blur', 'change'] },
          ],
          productParentName: [
            { required: true, message: '请选择商品大类', trigger: ['blur', 'change'] },
          ],
          externalPriceType: [
            { required: true, message: '请选择价格类型', trigger: ['blur', 'change'] },
          ],
          productProperty: [
            { required: !this.isHnFlag, message: '请选择产品属性', trigger: ['blur', 'change'] },
          ],
          startTime: [{ required: true, message: '请选择开始日期', trigger: ['blur', 'change'] }],
          endTime: [{ required: true, message: '请选择结束日期', trigger: ['blur', 'change'] }],
        };
      },

      externalPriceTypeList() {
        // 价格类型下拉
        let dictType = this.isHnFlag ? 'external_price_type_hn' : 'external_price_type';
        let dictList = this.$baseRequest.getDictListMapByType(dictType) || [];
        if (dictList[0]) {
          dictList.forEach((item) => {
            // 添加年份
            if (item.value === 'WBJG04' || item.value === 'WBJG02') {
              item.children = this.yearsList;
              item.children.forEach((el) => {
                // 添加月份
                el.children = this.monthList;
              });
            }
          });
        }
        return dictList;
      },
    },
    data() {
      return {
        isHnFlag: false,
        menuButtonList: [],
        searchForm: {
          partnerName: null, //合作伙伴
          businessDepartmentCode: null, // 部门编码
          productParentCode: null, // 商品大类编码
          productParentName: null, // 商品大类名称
          id: null, // 商品大类
          productCode: null, // 商品小类
          externalPriceType: null, // 价格类型
          priceYear: null, // 年
          priceMonth: null, // 月
          productProperty: [], // 产品属性
          tradeCurrencyCode: null, // 交易币种
          tradeCurrencyName: null, // 交易币种名称
          otherCurrency: null, // 其他币种
          productStatus: [], // 货物状态
          tradeMarket: [], // 交易市场
          startTime: null, // 开始时间
          endTime: null, // 结束时间
          averagePrice: null, // 显示上述日期范围内均价
          averagePriceValue: null, // 均价
        },
        timeData: {
          // 存放价格类型后缀年月
          settlementPriceYear: null, // 期货结算价格年
          settlementPriceMonth: null, // 期货结算价格月
          closePriceYear: null, // 期货收盘价格年
          closePriceMonth: null, // 期货收盘价格月
        },
        searchDialog: {
          API: API.LIST_PRODUCT, // 商品大类
          query: {
            productChName: null,
            parentProductStatus: 'ZT03',
            detailProductStatus: 'ZT03',
          },
          propName: 'productChName',
          searchColumns: [
            {
              prop: 'productChName',
              name: this.$t('outsidePrice.label.productName'),
              type: 'input',
              placeholder: this.$t('outsidePrice.placeholder.productName'),
            },
          ],
          columnList: [
            { prop: 'productChName', label: this.$t('outsidePrice.label.ZHName') },
            { prop: 'parentProductNo', label: this.$t('outsidePrice.label.productCode') },
            {
              prop: 'parentProductStatusName',
              label: this.$t('outsidePrice.label.productStatus_st'),
            },
          ],
        },
        yearsList: [], // 未来五年
        monthList: [], // 月份
        expandText: this.$t('search.spread'),
        icon: 'el-icon-arrow-down',
        expand: false, // 收起or展开
        detailProductList: [], // 商品小类
        tradeCurrencyList: [], // 其他货币
        departmentList: [], // 部门下拉
        productPropertyList: [], // 产品属性下拉
        productStatusList: [], // 货物状态
        tradeMarketList: [], // 交易市场下拉
        load: false,
        tableData: [], // 表格数据
        multipleSelection: [], // 选中行数据
        pickerStartOptions: {
          disabledDate: (time) => {
            // 可选范围为一个月的数据 TODO：润月问题待解决
            if (this.searchForm.endTime) {
              return (
                time.getTime() >= new Date(this.searchForm.endTime).getTime() ||
                time.getTime() <=
                  new Date(this.searchForm.endTime).getTime() - 3600 * 24 * 1000 * 30
              );
            }
          },
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            if (this.searchForm.startTime) {
              return (
                time.getTime() <=
                  new Date(this.searchForm.startTime).getTime() - 3600 * 24 * 1000 ||
                time.getTime() >=
                  new Date(this.searchForm.startTime).getTime() + 3600 * 24 * 1000 * 30
              );
            }
          },
        },
        columnList: [],
      };
    },
    mounted() {
      this.getYearsList(); // 获取后五年
      this.getMonthList();
      this.getDictList(); // 获取字典表值
      this.getdepartmentList(); // 获取部门
      // this.getData(); // 获取表格数据
      this.getButtonList();
      this.setIIsHnFlag();
    },
    methods: {
      setIIsHnFlag() {
        // 切换到海宁
        this.$baseRequest
          .getSysConfigByCompany({
            code: 'EXTERNAL_PRICE_HN',
            companyCode: this.userInfo.companyCode,
          })
          .then((res) => {
            this.isHnFlag = res == 'Y' || false;
          });
      },
      // 获取外部价格列表
      getData() {
        var year = new Date().getFullYear();
        var month = new Date().getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        this.searchForm.startTime = `${year}-${month}-01`;
        this.searchForm.endTime = dateFormat(new Date());
        const params = this.resolveSearchData(); // 获取并处理筛选条件
        this.$axios.post(API.LIST_EXTERNAL_PRICE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      chooseClick(type) {
        if (type == 'add') {
          let path = {
            path: '/masterData/addoutsidePrice',
            name: 'addoutsidePrice',
            meta: {
              keepAlive: false,
              title: '新建外部价格主数据',
            },
            query: {},
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type == 'priceChart') {
          this.priceChart();
        } else if (type == 'export') {
          this.handleExport();
        } else if (type == 'import') {
          this.importOrder();
        }
      },
      //导入
      importOrder() {
        this.$refs.siruiUpload.openDialog(true);
      },
      dblclickEvent(value) {
        let path = {
          path: '/masterData/editOutsidePrice',
          name: 'editOutsidePrice',
          meta: {
            keepAlive: false,
            title: '编辑外部价格主数据',
          },
          query: {
            data: JSON.stringify(value.row),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 生成价格趋势图
      priceChart() {
        if (this.tableData.length !== 0) {
          this.$refs.priceEchart.openDialog(this.tableData);
        } else {
          this.$message({
            showClose: true,
            message: this.$t('outsidePrice.message.noData'),
            type: 'error',
          });
        }
      },
      // 导出文件
      handleExport() {
        let params = this.resolveSearchData(); // 获取并处理筛选条件
        if (this.multipleSelection.length > 0) {
          params.idList = this.multipleSelection.map((item) => {
            return item.id;
          });
        }
        this.loading.startLoading();
        this.$axios.post(API.EXPORT_EXTERNAL_PRICE, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
      },
      // 选择交易币种
      tradeCurrencyChange(value) {
        if (value !== 'other') {
          this.searchForm.tradeCurrencyName = this.oftenCurrencyList.find(
            () => value === this.searchForm.tradeCurrencyCode
          ).label;
          this.searchForm.otherCurrency = '';
        } else {
          this.searchForm.tradeCurrencyName = '';
          this.searchForm.otherCurrency = this.tradeCurrencyList[0].value;
        }
      },
      // 其他货币下拉获得焦点
      otherCurrencyFocus() {
        this.searchForm.tradeCurrencyCode = 'other';
      },
      // 商品大类搜索弹出框确定
      setSearchModal(model, row) {
        if (row) {
          this.searchForm.productParentName = row[0].productChName; // 输入框展示name（子类）
          this.searchForm.productParentCode = row[0].parentProductNo; // 子类code
          this.searchForm.id = row[0].id; // 子类code
          this.getProductDetail(row[0].id);
        }
      },
      // 获取商品小类
      getProductDetail(id) {
        this.searchForm.productCode = null;
        this.detailProductList = [];
        this.$axios
          .post(API.GET_PRODUCT_DETAIL, { id: id, detailProductStatus: 'ZT03' })
          .then((res) => {
            if (res.data.code === 0) {
              let detailList = res.data.data.productDetails;
              detailList.forEach((item) => {
                this.detailProductList.push({
                  label: item.detailProductDisplayName,
                  value: item.productDetailCode,
                });
              });
            }
          });
      },
      // 获取并处理筛选条件
      resolveSearchData() {
        const params = JSON.parse(JSON.stringify(this.searchForm));
        if (params.tradeCurrencyCode === 'other') {
          params.tradeCurrencyCode = params.otherCurrency;
          params.tradeCurrencyName = this.tradeCurrencyList.find(
            (item) => item.value === params.otherCurrency
          ).label;
        }
        if (params.externalPriceType) {
          const arr = JSON.parse(JSON.stringify(params.externalPriceType));
          params.priceYear = arr[1];
          params.priceMonth = arr[2];
          params.externalPriceType = arr[0];
        }
        params.productProperty = JSON.stringify(params.productProperty);
        params.productStatus = JSON.stringify(params.productStatus);
        params.tradeMarket = JSON.stringify(params.tradeMarket);
        return params;
      },
      // 搜索
      search() {
        this.searchForm.averagePrice = null; // 搜索时将均价清空
        this.searchForm.averagePriceValue = null;
        const params = this.resolveSearchData(); // 获取并处理筛选条件
        this.$refs.searchForm.validate((valid) => {
          if (valid) {
            this.$axios.post(API.LIST_EXTERNAL_PRICE, params).then((res) => {
              if (res.data.code === 0) {
                this.tableData = res.data.data;
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('outsidePrice.message.noPerfect'),
              type: 'error',
            });
          }
        });
      },
      // 获取均价
      getPriceValue(value) {
        const params = this.resolveSearchData(); // 获取并处理筛选条件
        //上述日期范围内均价   产品名称要一样
        if (!this.isAllEqual(this.tableData)) {
          this.searchForm.averagePrice = null;
          this.searchForm.averagePriceValue = null;
          return this.$message({
            showClose: true,
            message: this.$t('outsidePrice.message.noGetPrice'),
            type: 'error',
          });
        }
        if (value) {
          // 被勾选
          this.$refs.searchForm.validate((valid) => {
            // 校验通过
            if (valid) {
              this.$axios.get(API.GET_PRICE_VALUE, params).then((res) => {
                if (res.data.code === 0) {
                  this.searchForm.averagePriceValue = res.data.data;
                } else {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                }
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('outsidePrice.message.noPass'),
                type: 'error',
              });
            }
          });
        } else {
          this.searchForm.averagePriceValue = null;
        }
      },
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value) {
            return value.productName !== array[0].productName;
          });
        } else {
          return true;
        }
      },
      // 重置
      reset() {
        this.$refs.searchModal.resetClick(); // 产品名称弹出表格重置
        this.$refs.siruiTable.clearCheckboxReserve();
        this.searchForm.productCode = '';
        this.searchForm.productParentCode = '';
        this.detailProductList = [];
        this.searchForm.externalPriceType = null;
        this.$nextTick(() => {
          this.$refs.searchForm.resetFields();
          this.getData(true);
        });
      },
      // 收起展开
      toggle() {
        this.expand = !this.expand;
        this.expandText =
          this.expandText == this.$t('search.spread')
            ? this.$t('search.packUp')
            : this.$t('search.spread');
        this.icon = this.icon == 'el-icon-arrow-down' ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
      },
      // 获取字典表值
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 货币 (币种管理 )
        // this.$axios.get(API.LIST_CURRENCY).then(res => {
        // 	if(res.data.code === 0) {
        // 	this.tradeCurrencyList = [];
        // 	res.data.data.forEach(item => {
        // 		let obj = {
        // 		label: item.currencyName,
        // 		value: item.currencyCode,
        // 					};
        // 		this.tradeCurrencyList.push(obj)
        // 	})
        // 	} else {
        // 	this.$message({ showClose: true, message: res.data.msg, type: "error" });
        // 	}
        // });
        // 货币 (币种管理 )
        this.$axios.get(API.LIST_CURRENCY).then((res) => {
          if (res.data.code === 0) {
            this.tradeCurrencyList = [];
            res.data.data.forEach((item) => {
              let obj = {
                label: item.currencyName,
                value: item.currencyCode,
              };
              this.tradeCurrencyList.push(obj);
            });
            let arrIdList = this.oftenCurrencyList.map((x) => x.value);
            this.tradeCurrencyList = this.tradeCurrencyList.filter(
              (x) => !arrIdList.includes(x.value)
            );
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 产品属性
        this.$axios
          .post(API.DICT_LIST, { dictType: 'product_property', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.productPropertyList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 货物状态
        this.$axios.post(API.DICT_LIST, { dictType: 'product_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.productStatusList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
        // 交易市场
        this.$axios.post(API.DICT_LIST, { dictType: 'trade_market', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.tradeMarketList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 获取部门
      getdepartmentList() {
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          }
        });
      },
      // 12个月份下拉
      getMonthList() {
        for (var i = 1; i <= 12; i++) {
          let obj = {};
          obj.label = i + '月份';
          obj.value = i < 10 ? '0' + i.toString() : i.toString(); // 月份前加0
          this.monthList.push(obj);
        }
      },
      // 后五年的下拉
      getYearsList() {
        let year = new Date().getFullYear() - 1;
        for (var i = 0; i <= 5; i++) {
          year++;
          let obj = {};
          obj.label = year.toString() + '年';
          obj.value = year.toString();
          this.yearsList.push(obj);
        }
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;
  .outsidePrice .search {
    background: #fff;
    border-radius: 4px;
    padding: 15px 20px;
    box-shadow: 0px 1px 5px #ddd;
  }
  //.outsidePrice .search .el-form-item {
  //	margin-bottom: 12px;
  //}
  //.outsidePrice .search .searchBtns {
  //	text-align: right;
  //}
  //.outsidePrice .search .search-expand {
  //	cursor: pointer;
  //	margin: 0 0 0 8px;
  //	font-size: 12px;
  //	color: $maintheme;
  //}
  //.el-button {
  //	border-radius: 3px;
  //	border: 1px solid #6299fe;
  //	color: #6299fe;
  //}
  //.el-button--primary {
  //	background-color: $maintheme;
  //	border-color: $maintheme;
  //	color: #fff;
  //}
  .searchBtns {
    text-align: right;
    a {
      display: inline-block;
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
      margin-right: 10px;
      text-align: center;
      font-size: 14px;
    }
    img {
      vertical-align: middle;
      padding-right: 6px;
    }
    .search-btn {
      background-color: #409eff;
      color: #ffffff;
    }
    .reset {
      border: 1px solid #e4e6eb;
      color: #409eff;
    }
    .open-btn {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #e4e6eb;
      display: inline-block;
      cursor: pointer;
      color: #00b400;
      text-align: center;
      border-radius: 3px;
      img {
        padding-right: 0;
      }
    }
    .active {
      transform: rotate(180deg);
    }
  }
  .search {
    ::v-deep .el-select {
      width: 100%;
    }
  }
</style>
